import { cva } from '@vizit/theme';

/**
 * Shared styles for "sectioned" dropdown menus — a `MenuPopover`/`Menu` whose
 * `MenuSection`s carry uppercase mono headers and optional dividers between
 * sections (the paradigm used by the workspace switcher and the assets filter
 * menu). Item styles are intentionally not shared: each consumer styles its own
 * rows.
 */
export const sectionedMenuStyles = {
  popover: cva({ base: 'shadow-lg py-2 min-w-[240px]' }),
  menu: cva({ base: 'py-0 outline-none' }),
  section: cva({
    base: 'outline-none',
    variants: { withDivider: { true: 'mt-2 pt-2 border-t border-secondary' } },
  }),
  header: cva({
    base: 'block font-mono font-bold text-xs px-8 py-6',
    variants: { emphasized: { true: 'text-tertiary', false: 'text-quaternary' } },
    defaultVariants: { emphasized: false },
  }),
};
